import { Link } from "react-router-dom";
import { ArrowRight, Check, MapPin } from "lucide-react";

const H = { fontFamily: "Quicksand, sans-serif" };

export default function CityConciergerieSection({ city, nearby = [] }) {
  const faq = city.faq || [];
  return (
    <section className="py-16 md:py-24" data-testid="city-conciergerie-section">
      <div className="container-tm grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <span className="pill">Conciergerie {city.name}</span>
          <h2 className="h-section mt-4">
            Conciergerie Airbnb à <span className="text-accent">{city.name}</span> : comparez sans démarcher
          </h2>
          <p className="mt-5 text-foreground/85 leading-relaxed">
            Vous cherchez une conciergerie Airbnb à {city.name} ? Plutôt que d&apos;appeler plusieurs conciergeries, décrivez votre bien une seule fois.
            Bretagne Conciergerie Comparateur vous met en relation avec la conciergerie la plus adaptée à votre logement, à votre budget et aux services dont vous avez besoin :
            ménage, accueil des voyageurs, annonce, prix dynamiques.
          </p>
          <div className="mt-8 space-y-5">
            {faq.map((f, i) => (
              <div key={f.q} className="border-b border-border pb-5" data-testid={`city-faq-${i}`}>
                <h3 className="font-bold text-lg" style={H}>{f.q}</h3>
                <p className="mt-2 text-muted-foreground leading-relaxed">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="rounded-3xl bg-accent text-accent-foreground p-8 md:p-10 lg:sticky lg:top-28">
            <h3 className="text-2xl md:text-3xl font-bold tracking-tight" style={H}>Votre devis conciergerie à {city.name}</h3>
            <ul className="mt-6 space-y-3 text-sm">
              {["0 € pour le propriétaire, sans engagement", "Une conciergerie qui connaît votre secteur", "Rappel par téléphone, 7j/7 de 10h à 20h"].map((b) => (
                <li key={b} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-white text-accent flex items-center justify-center shrink-0"><Check size={12} strokeWidth={3} /></span>
                  {b}
                </li>
              ))}
            </ul>
            <Link to={`/devis?ville=${city.slug}`} className="mt-8 inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-3.5 font-semibold hover:bg-primary/90 transition-colors" data-testid="city-quote-cta">
              Demander mon devis gratuit <ArrowRight size={16} />
            </Link>
          </div>
          {city.guide_slug && (
            <Link to={`/blog/${city.guide_slug}`} className="mt-6 surface-card p-6 flex items-center justify-between gap-4 hover:border-accent transition-colors" data-testid="city-guide-link">
              <div>
                <div className="text-xs uppercase tracking-widest text-[hsl(var(--ocean))] font-bold">Guide complet</div>
                <div className="font-bold mt-1" style={H}>Conciergerie Airbnb à {city.name} : tarifs et conseils</div>
              </div>
              <ArrowRight size={18} className="text-accent shrink-0" />
            </Link>
          )}
          {city.related_posts?.length > 0 && (
            <div className="mt-6 surface-card p-6" data-testid="city-related-posts">
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">À lire aussi</div>
              <ul className="mt-3 space-y-2">
                {city.related_posts.map((p) => (
                  <li key={p.slug}>
                    <Link to={`/blog/${p.slug}`} className="text-sm font-semibold hover:text-accent transition-colors" data-testid={`related-post-${p.slug}`}>{p.title}</Link>
                  </li>
                ))}
                {city.further_reading && (
                  <li>
                    <a href={city.further_reading.url} className="text-sm font-semibold hover:text-accent transition-colors" data-testid="further-reading-link">{city.further_reading.label}</a>
                  </li>
                )}
              </ul>
            </div>
          )}
          {nearby.length > 0 && (
            <div className="mt-6 surface-card p-6" data-testid="city-nearby">
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Communes proches</div>
              <div className="mt-3 flex flex-wrap gap-2">
                {nearby.map((c) => (
                  <Link key={c.slug} to={`/villes/${c.slug}`} className="inline-flex items-center gap-1 text-sm px-3 py-1.5 rounded-full bg-secondary hover:bg-accent/10 transition-colors" data-testid={`nearby-${c.slug}`}>
                    <MapPin size={11} className="text-accent" /> {c.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
